import {TypeformSurveyComponent} from './typeform-survey.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [CommonModule],
    exports: [TypeformSurveyComponent],
    declarations: [TypeformSurveyComponent]
})
export class TypeformSurveyModule {}
